import { MDBBtn, MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import {
    forwardRef,
    MutableRefObject,
    ReactElement,
    useEffect,
    useRef,
    useState,
} from "react";
import ModalMap from "@/components/detail/ModalMap";
import { laodMore } from "@/utils/analytics/tagmanager";
import TagManager from "react-gtm-module";
import { ItinerariesReadableTO, TourReadableTO } from "../../models/detail";
import styles from "../../styles/detail/Detail.TravelExperiencesStep.module.scss";
import useForwardRef from "../../utils/hooks/useForwardRef";
import { qualityPremiumContent } from "../../utils/mockData/infoMock";
import userInterfaceSvg from "../../utils/svg-icon/userInterface";
import InfoModalDouble from "../common/info/InfoModalDouble";
import TravelExperiencesStepCard from "./TravelExperiencesStepCard";
import { useIsMD } from "../../utils/hooks/useWindowSizes";
import { useStore } from "../../store";
import useOnScreen from "../../utils/hooks/useOnScreen";
import { EDetailSection } from "../../models/common/enums";

const TravelExperiencesStep = forwardRef<
    HTMLDivElement,
    {
        itineraries: ItinerariesReadableTO[];
        isPremium: boolean;
        packageDetail: TourReadableTO;
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
>(
    (
        { itineraries, isPremium, packageDetail },
        ref
        // eslint-disable-next-line sonarjs/cognitive-complexity
    ): ReactElement => {
        const travelExperiencesStepSection =
            useForwardRef<HTMLInputElement>(ref);
        const dispatch = useStore(state => state.dispatchPackage);

        const isOnScreen = useOnScreen(travelExperiencesStepSection);
        // const { InfoCircleLine } = contactsSvg;
        const { ArrowDownSimpleLine } = userInterfaceSvg;
        const minimumVisibleCards = 4;
        const [visibleCards, setVisibleCards] = useState<number>(4);
        const [showModalMap, setShowModalMap] = useState<boolean>(false);

        const shouldBeExpandable = () => {
            return itineraries.length > minimumVisibleCards;
        };

        const shouldAddTransparency = (currentIndex: number) => {
            return (
                visibleCards < itineraries.length &&
                currentIndex >= visibleCards &&
                shouldBeExpandable()
            );
        };

        const isAllCardsVisible = () => {
            return visibleCards === itineraries.length;
        };

        // const title: ISectionTitle = {
        //     title: travelExperiencesTitleGreen,
        //     subTitle: travelExperiencesSubTitle,
        //     classNameContainer: "p-0",
        //     alignment: "justify-content-center text-center",
        // };

        const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

        const isMD = useIsMD();

        const divColCards = useRef() as MutableRefObject<HTMLDivElement>;
        const [clientHeight, setClientHeight] = useState(0);

        const checkAtlasMap = (): string | undefined => {
            const map = packageDetail.atlasMap;
            const baseUrlAtlasMap =
                process.env.NEXT_PUBLIC_ATLASMAP_BASE_URL ??
                "https://my.atlist.com/map";

            const flag = map?.includes(baseUrlAtlasMap);
            if (flag) return map;
            return "https://my.atlistmaps.com/map/6bff2890-48de-4852-9a3e-7c2e6d5d048f?share=true";
        };

        useEffect(() => {
            if (!divColCards.current) return;
            const resizeObserver = new ResizeObserver(() => {
                setClientHeight(divColCards.current.clientHeight);
            });
            resizeObserver.observe(divColCards.current);
            // eslint-disable-next-line consistent-return
            return () => resizeObserver.disconnect();
        }, []);

        useEffect(() => {
            if (isOnScreen) {
                dispatch({
                    type: "SET_CURRENT_SECTION",
                    payload: EDetailSection.ITINERARY,
                });
            }
        }, [isOnScreen]);

        /* eslint-disable react/no-array-index-key */
        return (
            <MDBContainer
                fluid
                className={styles.travelSectionBgColor}
                ref={travelExperiencesStepSection}
            >
                {/* <MDBRow className="px-3 justify-content-center p-lg-0">
                    <SectionTitle sectionTitle={title} />
                </MDBRow>
                {typePackage === ETypePackage.QUALITY_AND_PREMIUM && (
                    <>
                        <MDBRow
                            className="justify-content-center"
                            role="button"
                            tabIndex={0}
                            onClick={() => setShowInfoModal(true)}
                        >
                            <MDBCol className={styles.info}>
                                <p>Choose your esperienza</p>
                                <InfoCircleLine />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="justify-content-center mt-3">
                            <div className="d-flex justify-content-center mt-1 mb-2">
                                <span
                                    className={
                                        !isPremium
                                            ? `pe-3 ${styles.cardSecondaryTextBold}`
                                            : `pe-3 ${styles.cardSecondaryText}`
                                    }
                                >
                                    Quality
                                </span>
                                <MDBSwitch
                                    checked={isPremium}
                                    onChange={() => {
                                        setIsPremium(!isPremium);
                                        // const url = new URL(
                                        //     window.location.href
                                        // );
                                        // url.searchParams.set(
                                        //     "isPremium",
                                        //     !isPremium as unknown as string
                                        // );
                                        // window.history.replaceState(
                                        //     null,
                                        //     "",
                                        //     url
                                        // );
                                    }}
                                    className={styles.customSwitch}
                                />
                                <span
                                    className={
                                        isPremium
                                            ? `ps-3 ${styles.cardSecondaryTextBold}`
                                            : `ps-3 ${styles.cardSecondaryText}`
                                    }
                                >
                                    Premium
                                </span>
                            </div>
                        </MDBRow>
                    </>
                )}

                {typePackage !== ETypePackage.QUALITY_AND_PREMIUM && (
                    <TagsPackageType
                        isPremium={typePackage === ETypePackage.ONLY_PREMIUM}
                    />
                )} */}
                <MDBRow className="align-items-start mt-5">
                    <div className={styles.divComtainer}>
                        <MDBCol
                            size={12}
                            lg={7}
                            ref={divColCards}
                            className={styles.divColCards}
                        >
                            {itineraries.map((el, id) => (
                                <MDBRow
                                    key={`${el.day}_${id}`}
                                    className={`${
                                        id < visibleCards
                                            ? "d-flex m-2"
                                            : "d-none m-2"
                                    }`}
                                >
                                    <MDBCol size={1}>
                                        {/* eslint-disable-next-line no-underscore-dangle */}
                                        <span key={el.itinerary._id}>
                                            <div
                                                className={styles.numberStep}
                                            >{`${
                                                id >= 9 ? id + 1 : `0${id + 1}`
                                            }`}</div>
                                        </span>
                                    </MDBCol>
                                    <MDBCol
                                        className="ps-4"
                                        style={{ position: "relative" }}
                                    >
                                        <TravelExperiencesStepCard
                                            isPremium={isPremium}
                                            cardData={el}
                                            setShow={setShowModalMap}
                                        />
                                        {shouldAddTransparency(id + 1) && (
                                            <div className={styles.gradient} />
                                        )}
                                    </MDBCol>
                                </MDBRow>
                            ))}
                            {shouldBeExpandable() && (
                                <MDBRow className="justify-content-center p-5">
                                    <MDBCol className="d-inline-flex justify-content-center">
                                        <MDBBtn
                                            className={`${
                                                isAllCardsVisible()
                                                    ? styles.buttonMainActionRotate
                                                    : styles.buttonMainAction
                                            } mx-2 shadow-0`}
                                            color="danger"
                                            onClick={() => {
                                                // eslint-disable-next-line no-unused-expressions
                                                !isAllCardsVisible() &&
                                                    TagManager.dataLayer(
                                                        laodMore()
                                                    );
                                                setVisibleCards(
                                                    isAllCardsVisible()
                                                        ? minimumVisibleCards
                                                        : itineraries.length
                                                );
                                                window.scrollTo({
                                                    top: travelExperiencesStepSection
                                                        .current?.offsetTop,
                                                    behavior: "smooth",
                                                });
                                            }}
                                        >
                                            {isAllCardsVisible()
                                                ? "View Less"
                                                : "Load More"}
                                            <ArrowDownSimpleLine />
                                        </MDBBtn>
                                    </MDBCol>
                                </MDBRow>
                            )}
                        </MDBCol>
                    </div>
                    {!isMD && (
                        <MDBCol
                            size={5}
                            xl={4}
                            className={styles.divColMap}
                            style={{ height: clientHeight }}
                        >
                            <div className={styles.divCollst}>
                                <iframe
                                    id="map"
                                    src={checkAtlasMap()}
                                    allow="geolocation"
                                    className={styles.mapContainer}
                                    title="map"
                                    style={{
                                        overflowY: "hidden",
                                        width: "100%",
                                    }}
                                />
                            </div>
                        </MDBCol>
                    )}
                </MDBRow>
                <ModalMap
                    url={checkAtlasMap()}
                    show={showModalMap}
                    setShow={setShowModalMap}
                />
                <InfoModalDouble
                    content={qualityPremiumContent}
                    show={showInfoModal}
                    setShow={setShowInfoModal}
                />
            </MDBContainer>
        );
    }
);

export default TravelExperiencesStep;
